<h3>{{'Treatment plan' | translate}}</h3>
<div class="grid-container">
	<div class="row">
		<div class="header">{{ getHeadline(OrcadentQuestionnaireSection.PRE_ALIGNER_DISTRACTION_SPLINT) | translate}}</div>
		<div class="data">{{(questionnaireData.preAlignerDistractionSplint ? 'Yes' : 'No') | translate}}</div>
	</div>
	<div class="row">
		<div class="header">{{ getHeadline(OrcadentQuestionnaireSection.REMOVE_ATTACHMENTS_PRE_ALIGNER) | translate}}</div>
		<div class="uj-lj-grid">
			<div class="subheader">{{'UJ' | translate}}</div>
			<div class="subheader">{{'LJ' | translate}}</div>
			<div class="data">{{getRemoveAttachmentsPreAlignerAnswer(true)}}</div>
			<div class="data">{{getRemoveAttachmentsPreAlignerAnswer(false)}}</div>
		</div>
	</div>
	<div class="row">
		<div class="header">{{ getHeadline(OrcadentQuestionnaireSection.OCCLUSAL_HEIGHT_INSTRUCTION) | translate}}</div>
		<div class="data">{{questionnaireData.occlusalHeightInstruction.option | translate}}{{questionnaireData.occlusalHeightInstruction.text ? ': ' + questionnaireData.occlusalHeightInstruction.text  : ''}}</div>
	</div>
	<div class="row">
		<div class="header">{{ getHeadline(OrcadentQuestionnaireSection.NON_MOVING_TEETH) | translate}}</div>
		<div class="data">{{questionnaireData.nonMovingTeeth ?? '-'}}</div>
	</div>
	<div class="row">
		<div class="header">{{ getHeadline(OrcadentQuestionnaireSection.MIDDLELINE) | translate}}</div>
		<div class="uj-lj-grid">
			<div class="subheader">{{'UJ' | translate}}</div>
			<div class="subheader">{{'LJ' | translate}}</div>
			<div class="data">
				{{questionnaireData.middleline.uj.option | translate:{jaw: 'LJ' | translate} }}{{questionnaireData.middleline.uj.text ? ': ' + questionnaireData.middleline.uj.text  : ''}}
			</div>
			<div class="data">
				{{questionnaireData.middleline.lj.option | translate:{jaw: 'UJ' | translate} }}{{questionnaireData.middleline.lj.text ? ': ' + questionnaireData.middleline.lj.text  : ''}}
			</div>
		</div>
	</div>
	<div class="row">
		<div class="header">{{ getHeadline(OrcadentQuestionnaireSection.ANTERIOR_TEETH) | translate}}</div>
		<div class="uj-lj-grid">
			<div class="subheader">{{'UJ' | translate}}</div>
			<div class="subheader">{{'LJ' | translate}}</div>
			<div class="data" [innerHTML]="getAnteriorTeethAnswer(true)"></div>
			<div class="data" [innerHTML]="getAnteriorTeethAnswer(false)"></div>
		</div>
	</div>
	<div class="row">
		<div class="header">{{ getHeadline(OrcadentQuestionnaireSection.POSTERIOR_TEETH) | translate}}</div>
		<div class="quadrant-grid">
			<div class="subheader">Q1</div>
			<div class="subheader">Q2</div>
			<div class="subheader">Q3</div>
			<div class="subheader">Q4</div>
			<div class="data" [innerHTML]="getPosteriorTeethAnswer(Quadrant.Q1)"></div>
			<div class="data" [innerHTML]="getPosteriorTeethAnswer(Quadrant.Q2)"></div>
			<div class="data" [innerHTML]="getPosteriorTeethAnswer(Quadrant.Q3)"></div>
			<div class="data" [innerHTML]="getPosteriorTeethAnswer(Quadrant.Q4)"></div>
		</div>
	</div>
	<div class="row">
		<div class="header">{{ getHeadline(OrcadentQuestionnaireSection.REMOVE_ATTACHMENTS_FOR_MOVEMENT) | translate}}</div>
		<div class="uj-lj-grid">
			<div class="subheader">{{'UJ' | translate}}</div>
			<div class="subheader">{{'LJ' | translate}}</div>
			<div class="data">{{getRemoveAttachmentsForMovementAnswer(true)}}</div>
			<div class="data">{{getRemoveAttachmentsForMovementAnswer(false)}}</div>
		</div>
	</div>
	<div class="row">
		<div>
			<div class="header">{{ getHeadline(OrcadentQuestionnaireSection.ATTACHMENT_POSITION_MOVEMENT) | translate}}</div>
			<div class="subheader embedded">{{"according to Scheu protocol" | translate}}</div>
			<div class="subheader embedded">{{"labial/buccal" | translate}}</div>
			<div class="subheader embedded">{{"lingual/palatal" | translate}}</div>
		</div>
		<div class="position-attachment-grid">
			<div class="subheader">{{'UJ' | translate}}</div>
			<div class="subheader">{{'LJ' | translate}}</div>
			<!-- scheu protocol -->
			<div class="data">{{(questionnaireData.attachmentPositionMovement.uj.scheuProtocol ? 'Yes' : 'No') | translate}}</div>
			<div class="data">{{(questionnaireData.attachmentPositionMovement.lj.scheuProtocol ? 'Yes' : 'No') | translate}}</div>
			<!-- labial/buccal -->
			<div class="data">{{questionnaireData.attachmentPositionMovement.uj.labialBuccal ?? '-'}}</div>
			<div class="data">{{questionnaireData.attachmentPositionMovement.lj.labialBuccal ?? '-'}}</div>
			<!-- lingular/palatinal -->
			<div class="data">{{questionnaireData.attachmentPositionMovement.uj.lingualPalatal ?? '-'}}</div>
			<div class="data">{{questionnaireData.attachmentPositionMovement.lj.lingualPalatal ?? '-'}}</div>
		</div>
	</div>

	<div class="row">
		<div class="header">{{ getHeadline(OrcadentQuestionnaireSection.IPR) | translate}}</div>
		<div class="uj-lj-grid">
			<div class="subheader">{{'UJ' | translate}}</div>
			<div class="subheader">{{'LJ' | translate}}</div>
			<div class="data">{{getIprAnswer(true)}}</div>
			<div class="data">{{getIprAnswer(false)}}</div>
		</div>
	</div>

	<div class="row">
		<div class="header">{{getHeadline(OrcadentQuestionnaireSection.ELASTIC_CUTS)}}</div>
		@if(questionnaireData.elasticCuts) {
			<div class="data">{{'fromTo' | translate}}: {{questionnaireData.elasticCuts}}</div>
		}@else{
			<div class="data">-</div>
		}
	</div>

	<div class="row">
		<div class="header">{{getHeadline(OrcadentQuestionnaireSection.BUTTON_CUTS)}}</div>
		@if(questionnaireData.buttonCuts) {
			<div class="data">{{'at' | translate}}: {{questionnaireData.buttonCuts}}</div>
		}@else{
			<div class="data">-</div>
		}
	</div>
	<div class="row">
		<div class="header">{{getHeadline(OrcadentQuestionnaireSection.PONTICS)}}</div>
		<div class="uj-lj-grid">
			<div class="subheader">{{'half at' | translate}}</div>
			<div class="subheader">{{'full at' | translate}}</div>
			<div class="data">{{questionnaireData.pontics.half ?? '-'}}</div>
			<div class="data">{{questionnaireData.pontics.full ?? '-'}}</div>
		</div>
	</div>

	<div class="row">
		<div class="header">{{getHeadline(OrcadentQuestionnaireSection.ERUPTION_CAPS)}}</div>
		<div class="quadrant-grid">
			<div class="subheader">Q1</div>
			<div class="subheader">Q2</div>
			<div class="subheader">Q3</div>
			<div class="subheader">Q4</div>
			<div class="data">{{(questionnaireData.eruptionCaps.q1 ? 'Yes' : 'No') | translate}}</div>
			<div class="data">{{(questionnaireData.eruptionCaps.q2 ? 'Yes' : 'No') | translate}}</div>
			<div class="data">{{(questionnaireData.eruptionCaps.q3 ? 'Yes' : 'No') | translate}}</div>
			<div class="data">{{(questionnaireData.eruptionCaps.q4 ? 'Yes' : 'No') | translate}}</div>
		</div>
	</div>

	<div class="row">
		<div class="header">{{ getHeadline(OrcadentQuestionnaireSection.INDIVIDUAL_COMMENTS) | translate}}</div>
		<div class="data">{{questionnaireData.individualComments ?? '-'}}</div>
	</div>
</div>
<mat-dialog-actions align="end">
	<button mat-raised-button color="primary" (click)="printDialog()">{{'Print' | translate}}</button>
	<button mat-raised-button color="primary" mat-dialog-close>{{'Close' | translate}}</button>
 </mat-dialog-actions>
